'use client';
import './style.sass';

import React from 'react';
import {
    listPath,
    listTitle,
    targetList,
    listFrontend,
    listMatrixe,
    listBusiness,
    listResults,
} from './constans';
import TitleCase from '../../case-components/title-case';
import Target from '../reusable-components/target';
import Solution from '../reusable-components/layouts-component__skills-team/solution';
import Model from '../reusable-components/layouts-component__skills-team/model';
import Business from '../reusable-components/layouts-component__skills-team/business';
import Result from '../reusable-components/layouts-component__skills-team/results';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
const nextProjectdevRec = {
    nextProjectTitle: 'Новый сайт для Почта Банка',
    nextProjectImg: '/images/pic/cases-list-images/pochtabank.jpg',
    nextProjectLink: '/cases/development/pochtabank',
    nextProjectLinkTitle: '',
    nextProjectText:
        'Перенесли сайт на&nbsp;новую платформу с&nbsp;облачной архитектурой и&nbsp;создали конструктор для управления контентом',
};

const SkillsTeam = () => {
    return (
        <section>
            <TitleCase
                img="/images/pic/skills-team/skillsteam.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="skills-team"
            />
            <Target title={targetList.title} description={targetList.description} />
            <Solution listFrontend={listFrontend} />
            <Model listMatrixe={listMatrixe} />
            <Business listFrontend={listBusiness} />
            <Result list={listResults} />
            <NextProject NextProject={nextProjectdevRec} />
        </section>
    );
};

export default SkillsTeam;
